<!-- Dialog Header -->
<div class="dialog-header px-3 py-2">
  <span class="dialog-title">{{ heading }}</span>
  <button
    type="button"
    mat-icon-button
    class="dialog-close"
    (click)="closeDialog()"
    aria-label="Close dialog"
    [disableRipple]="true"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Table -->
<div class="table-container px-3 py-2">
  <table mat-table [dataSource]="dataSource" class="case-table">

    <!-- Dynamic Columns -->
    <ng-container [matColumnDef]="column" *ngFor="let column of displayColumns let idx = index">
      <th mat-header-cell *matHeaderCellDef [class.center-col]="idx === 0">
        {{ labelData[column] }}
      </th>
      <td
        mat-cell
        *matCellDef="let row; let i = index"
        (click)="selectRow(i)"
        [class.selected-row]="selectedRowIndex === i"
        [class.center-col]="idx === 0"
      >
        {{ row[column] || '-' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; let i = index; columns: displayColumns" class="hover-row" [class.alt-row]="i % 2 === 1"></tr>
  </table>
</div>

<!-- Footer Buttons -->
<div class="dialog-footer">
  <button mat-stroked-button (click)="closeDialog()">Cancel</button>
  
</div>
